import HTMLDOMParser from './index.js';

export default HTMLDOMParser;
